function templatePropertiesDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/template-properties/template-properties-dialog.html'
  }
}

export { templatePropertiesDialog }
